import React, { useState } from "react";

interface ApiErrorMessageProps {
  ApiError: { message?: string } | null;
}

const ApiErrorMessage: React.FC<ApiErrorMessageProps> = ({ ApiError }) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!ApiError || typeof ApiError !== "object" || !ApiError.message) return null;

  const cleanErrorMessage = (message: string): string => {
    return message
      .replace(/^(\d+):\s*\1\s*/g, "") 
      .replace(/^(\d+):\s*/g, "")       
      .replace(/^:\s*/, "");     
  };
  
  
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white text-gray-500 p-4 rounded-md shadow-md">
      <div className="text-center">
        <p className="text-lg font-semibold">
          No Data Available
          <sup className="ml-2 text-sm text-purple-600 cursor-pointer">
            <span onClick={() => setShowDetails(!showDetails)}>
              {showDetails ? "hide details" : "see details"}
            </span>
          </sup>
        </p>
        {showDetails && (
          <pre className="mt-4 whitespace-pre-wrap text-gray-600 text-left font-normal">
            {cleanErrorMessage(ApiError.message)}
          </pre>
        )}
      </div>
    </div>
  );
};

export default ApiErrorMessage;
